import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import TMHubReport from "./pages/TMHubReport/TMHubReport";

const theme = createTheme({
  typography: {
    fontFamily: '"Nunito Sans", "Nunito", system-ui, sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TMHubReport />
    </ThemeProvider>
  );
}

export default App;
